import { gql } from '@apollo/client';

export const UPDATE_RECIPE_DESCRIPTIONS = gql`
  mutation recipeDescriptions(
    $brandKey: BrandKey!
    $slideshowEditionId: String!
    $recipesUrls: [String]!
  ) {
    updateSlidehowRecipesDescriptions(
      brandKey: $brandKey
      slideshowEditionId: $slideshowEditionId
      recipesUrls: $recipesUrls
    ) {
      status
    }
  }
`;
